/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @next/next/no-img-element */
import React from 'react'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useRouter } from 'next/navigation';

function HomeLowestPrice({ items = [] }: { items?: any[] }) {


  const router = useRouter();

  return (
    <>
      <section className="home_sale_sc">
        <div className="container">
          <div className="s_head flex hd_4">
            <h2 className='fw_med'>Lowest Prices</h2>
          </div>
          <div className="sale_list gap_m">
            {items.map((item, index) => (
              <div key={`home-lowest-price-${item.id || 'no-id'}-${index}`} className="sale_item" 
              onClick={() => {
                const hasAllKeys = item?.banner_links?.every(
                  (link: any) => link?.linkable_id && link?.linkable_type && link?.type
                );

                if (hasAllKeys) {
                  if (item?.type === "brand") {
                    router.push(
                      `/product/product-category?brandIds=${item?.banner_links
                        ?.map((link: any) => link?.linkable_id)
                        .join(",")}`
                    );
                  } else if (item.type === "category") {
                    router.push(
                      `/product/product-category?categoryIds=${item?.banner_links
                        ?.map((link: any) => link?.linkable_id)
                        .join(",")}`
                    );
                  } else if (item.type === "product") {
                    router.push(
                      `/product/product-category?productIds=${item?.banner_links
                        ?.map((link: any) => link?.linkable_id)
                        .join(",")}`
                    );
                  } else {
                    router.push("/product/product-category?type=recommended");
                  }
                } else {
                  router.push("/product/product-category?type=recommended");
                }
              }}


                // router.push(`/product/product-category?type=lowest_price&search=${encodeURIComponent(item.title)}`)}
              
              >
                <figure>
                  <img src={item.image} alt={item.title} />
                </figure>
                <h3 style={{
                  borderTopLeftRadius: '25px',
                  borderTopRightRadius: '25px',
                  borderBottomLeftRadius: '0px',
                  borderBottomRightRadius: '0px',
                  width: '98%',
                  marginLeft: '2%',
                }}>{item.title}</h3>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  )
}

export default HomeLowestPrice